import { Styles } from "../../config"

import { stepClasses } from "@mui/material/Step"
import { stepConnectorClasses } from "@mui/material/StepConnector"
import { stepIconClasses } from "@mui/material/StepIcon"

let devBorder = ""
if (false) devBorder = "1px solid gray"

const styles = {
	container: {
		border: devBorder,

		width: "100%",
		padding: "10px",
		justifyContent: "center",
		alignItems: "center",

		"@media (max-width: 600px)": {
			width: "95%"
		}
	},

	timeline: {
		border: devBorder,

		width: "100%"
	},

	step: {
		[`&.${stepClasses.root}`]: {
			padding: "0px"
		}
	},

	connector({ lastStepError }) {
		let borderColor = Styles.Color.success
		if (lastStepError) borderColor = Styles.Color.error

		return {
			[`&.${stepConnectorClasses.alternativeLabel}`]: {
				top: "11px",
				left: "calc(-50% + 20px)",
				right: "calc(50% + 20px)"
			},

			[`& .${stepConnectorClasses.line}`]: {
				borderColor: Styles.Color.gray,
				borderTopWidth: "3px",
				borderRadius: 1
			},

			[`&.${stepConnectorClasses.active}`]: {
				[`& .${stepConnectorClasses.line}`]: {
					borderColor: borderColor,
					opacity: "0.7"
				}
			},

			[`&.${stepConnectorClasses.completed}`]: {
				[`& .${stepConnectorClasses.line}`]: {
					borderColor: borderColor,
					opacity: "0.7"
				}
			}
		}
	},

	icon({ error }) {
		let color = Styles.Color.success
		if (error) color = Styles.Color.error

		return {
			border: devBorder,

			[`&.${stepIconClasses.root}`]: {
				fontSize: "25px",
				color: Styles.Color.gray
			},

			[`&.${stepIconClasses.active}`]: {
				color: color
			}
		}
	},

	label: {
		border: devBorder,

		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t4.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t7.size
		},

		"@media (max-width: 800px)": {
			fontSize: "11px"
		},

		"@media (max-width: 600px)": {
			fontSize: "9px"
		}
	},

	value: {
		border: devBorder,

		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t7.size
		},

		"@media (max-width: 800px)": {
			fontSize: "11px"
		},

		"@media (max-width: 600px)": {
			fontSize: "9px"
		}
	}
}

export default styles
